import React, { Component } from 'react'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Security from '../../commons/security/Security.js'
import { FormattedMessage, injectIntl } from 'react-intl'
import Loading from '../ui/Loading.js'
import Timezone from '../../commons/timezone/Timezone.js'

class TicketMovilMantenimientos extends Component {
  constructor(props) {
    super(props)
    this.ajaxHandler = new AjaxHandler()
    this.state = {
      loading: false,
      preventivos: [],
      vencimientos: [],
      activeTab: Security.hasPermission('PREVENTIVOS_MOVIL_LISTAR') ? 'preventivos' : 'vencimientos'
    }
  }

  componentDidMount() {
    this.ajaxHandler.subscribe(this)
    this.loadData()
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe()
  }

  loadData() {
    this.setState({ loading: true })
    const movilId = this.props.movilId
    const pending = []

    if (Security.hasPermission('PREVENTIVOS_MOVIL_LISTAR')) {
      pending.push(
        this.ajaxHandler.getJson('/preventivos/movil/' + movilId)
          .then(data => { if (data) this.setState({ preventivos: data }) })
      )
    }

    if (Security.hasPermission('VENCIMIENTOS_MOVIL_LISTAR')) {
      pending.push(
        this.ajaxHandler.getJson('/vencimientos/movil/' + movilId)
          .then(data => { if (data && data[0]) this.setState({ vencimientos: data[0] }) })
      )
    }

    Promise.all(pending)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }))
  }

  render() {
    if (this.state.loading) return <Loading />

    const { preventivos, vencimientos, activeTab } = this.state
    const canVerPreventivos = Security.hasPermission('PREVENTIVOS_MOVIL_LISTAR')
    const canVerVencimientos = Security.hasPermission('VENCIMIENTOS_MOVIL_LISTAR')

    return (
      <div>
        <ul className="nav nav-tabs" role="tablist">
          {canVerPreventivos && (
            <li className="nav-item">
              <a
                className={'nav-link' + (activeTab === 'preventivos' ? ' active' : '')}
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ activeTab: 'preventivos' })}
              >
                <FormattedMessage id="ticketMovilMantenimientos.tab.preventivos" defaultMessage="Preventivos" />
              </a>
            </li>
          )}
          {canVerVencimientos && (
            <li className="nav-item">
              <a
                className={'nav-link' + (activeTab === 'vencimientos' ? ' active' : '')}
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ activeTab: 'vencimientos' })}
              >
                <FormattedMessage id="ticketMovilMantenimientos.tab.vencimientos" defaultMessage="Vencimientos" />
              </a>
            </li>
          )}
        </ul>

        <div className="tab-content pt-3">
          {canVerPreventivos && activeTab === 'preventivos' && (
            preventivos.length === 0
              ? (
                <div className="text-center p-3 text-muted">
                  <FormattedMessage id="ticketMovilMantenimientos.preventivos.sin_resultados" defaultMessage="No posee controles de mantenimiento preventivo." />
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm table-hover">
                    <thead className="thead-fleet">
                      <tr>
                        <th><FormattedMessage id="ticketMovilMantenimientos.preventivos.tabla.servicio" defaultMessage="Servicio" /></th>
                        <th><FormattedMessage id="ticketMovilMantenimientos.preventivos.tabla.medidor_al_alta" defaultMessage="Medidor al Alta" /></th>
                        <th><FormattedMessage id="ticketMovilMantenimientos.preventivos.tabla.realizar" defaultMessage="Realizar" /></th>
                        <th><FormattedMessage id="ticketMovilMantenimientos.preventivos.tabla.repetir" defaultMessage="Repetir" /></th>
                        <th><FormattedMessage id="ticketMovilMantenimientos.preventivos.tabla.alertar" defaultMessage="Alertar" /></th>
                      </tr>
                    </thead>
                    <tbody>
                      {preventivos.map(p => (
                        <tr key={p.id}>
                          <td className="align-middle">{p.servicio ? p.servicio.nombre : '-'}</td>
                          <td className="align-middle">{p.kmsAlAlta !== null && p.kmsAlAlta !== undefined ? p.kmsAlAlta : '-'}</td>
                          <td className="align-middle">{p.realizarALos !== null && p.realizarALos !== undefined ? p.realizarALos : '-'}</td>
                          <td className="align-middle">{p.servicio && p.servicio.preventivoCadaKms !== null && p.servicio.preventivoCadaKms !== undefined ? p.servicio.preventivoCadaKms : '-'}</td>
                          <td className="align-middle">{p.servicio && p.servicio.preventivoAlertarKmsPrevios !== null && p.servicio.preventivoAlertarKmsPrevios !== undefined ? p.servicio.preventivoAlertarKmsPrevios : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
          )}

          {canVerVencimientos && activeTab === 'vencimientos' && (
            vencimientos.length === 0
              ? (
                <div className="text-center p-3 text-muted">
                  <FormattedMessage id="ticketMovilMantenimientos.vencimientos.sin_resultados" defaultMessage="No posee vencimientos." />
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm table-hover">
                    <thead className="thead-fleet">
                      <tr>
                        <th><FormattedMessage id="ticketMovilMantenimientos.vencimientos.tabla.fecha_alta" defaultMessage="Fecha de Alta" /></th>
                        <th><FormattedMessage id="ticketMovilMantenimientos.vencimientos.tabla.fecha_vencimiento" defaultMessage="Fecha de Vencimiento" /></th>
                        <th><FormattedMessage id="ticketMovilMantenimientos.vencimientos.tabla.servicio" defaultMessage="Servicio" /></th>
                      </tr>
                    </thead>
                    <tbody>
                      {vencimientos.map(v => (
                        <tr key={v.id}>
                          <td className="align-middle">{v.fechaAlta ? Timezone.getDateForClient(v.fechaAlta, null, 'DD/MM/YYYY') : '-'}</td>
                          <td className="align-middle">{v.fechaVencimiento ? Timezone.getDateForClient(v.fechaVencimiento, null, 'DD/MM/YYYY') : '-'}</td>
                          <td className="align-middle">{v.servicio ? v.servicio.nombre : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
          )}
        </div>
      </div>
    )
  }
}

export default injectIntl(TicketMovilMantenimientos)
